import proto from '../proto.bw.coffee'

export maxCoord = 4096
export coord = (x) -> if x > maxCoord then x - maxCoord*2 else if x < -maxCoord then x + maxCoord*2 else x
export angle = (x) -> if x > Math.PI then x - Math.PI*2 else if x < -Math.PI then x + Math.PI*2 else x

export class Game
	tickPeriod = 1000/25

	constructor: ->
		@bodies = new Array 256
		@players = []
		@explosions = []
		@kills = []
		@radar = []
		@alive = false
		@cfg =
			damping:
				Asteroid: 0.995
				BonusWeapon: 0.98
				BonusLife: 0.98

	tick: (state) ->
		tickTime = Date.now()
		@prevTickTime = @nextTickTime
		@nextTickTime or= tickTime
		@nextTickTime -= 2.5 if tickTime < @nextTickTime
		@nextTickTime += 2.5 if tickTime > @nextTickTime
		@nextTickTime += tickPeriod
		if @player and @player.skills
			for skill in @player.skills when skill.target and skill.target.deleted
				delete skill.target
		for body, id in @bodies when body and body.deleted
			@bodies[id] = undefined
		@radar = []
		@kills = @kills.filter (pk) -> tickTime - pk.time < 7000

		@player = @players[state.playerState.id] or= {}
		@alive = state.playerState.alive
		@player.ship?.energy = state.playerState.energy
		@player.levelProgress = state.playerState.levelProgress
		@player.skills ?= []
		for s, i in state.playerState.skills
			@player.skills[i] ?= {}
			Object.assign @player.skills[i], s
		for p in state.createdPlayers
			p.info.name or= 'Unnamed Alien'
			@players[p.id] = p
			@playersChanged = true
		for p in state.changedPlayers
			player = @players[p.id]
			player.level = p.level
			player.score = p.score
			player.team = p.team
			if p.died?
				slayer = @players[p.died.slayer]
				@kills.push
					slayer: slayer
					victim: player
					weapon: p.died.weapon
					time: @nextTickTime
				slayer?.lastKillTime = @nextTickTime
		for id in state.deletedPlayers
			delete @players[id]
		@round ?= {}
		if state.round.killsToWin
			@round.killsToWin = state.round.killsToWin
			@round.startTime = @nextTickTime
		if state.round.winner
			@round.winner = @players[state.round.winner]
			@round.finishTime = @nextTickTime
		for id in state.deletedBodies
			@bodies[id].deleted = true
		for b in state.createdBodies
			@bodies[b.id] =
				id: b.id
				type: b.type
				createTime: @nextTickTime
				radius: b.radius
				cx: coord state.origin.x + b.x
				cy: coord state.origin.y + b.y
				ca: 0
				damping: @cfg.damping[b.type] or 1
		for b in state.changedBodies
			body = @bodies[b.id]
			body.x = coord state.origin.x + b.x
			body.y = coord state.origin.y + b.y
			body.vx = b.vx
			body.vy = b.vy
			body.player = @players[b.owner]
			body.a = b.a if b.a?
			body.level = b.level if b.level?
			body.life = b.life if b.life?
			body.shield = b.shield if b.shield?
			if b.emotion?
				body.emotion = b.emotion
				body.emotionTime = @nextTickTime
			body.skill = b.skillType if b.skillType?
			body.time = @nextTickTime
			if body.type == 'Ship'
				body.player?.ship = body
		for e in state.explosions
			@explosions.push
				x: coord state.origin.x + e.x
				y: coord state.origin.y + e.y
				power: e.power
				type: e.type
				time: @nextTickTime
		for p in state.radarPoints
			@radar.push
				x: p.distance * Math.cos p.a
				y: p.distance * Math.sin p.a
				type: p.type



// WEBPACK FOOTER //
// ./client/game.coffee